import { XolaMobileApp } from "types";
import { useXolaMobileApps } from "@/components/MobileApps/XolaMobileAppsContext";

export const useSearchAutoFocus = () => {
    const { xolaMobileApp } = useXolaMobileApps();
    return xolaMobileApp !== XolaMobileApp.XolaTablet;
};
